import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import { TextField, Button } from "@material-ui/core";
import { postEscapeRoom } from "../../../../api/escape-room";
import { getDefaultRegistrationPage } from "./EscapeRoomEditor";
import { alertError, alertSuccess } from "../../../../utils/logger";

export default function EscapeRoomCreatePage() {
	const [name, setName] = useState("");
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	const handleSubmit = (e) => {
		if (e) e.preventDefault();
		if (!name.trim() || loading) return;
		setLoading(true);
		postEscapeRoom({
			name: name.trim(),
			pages: [getDefaultRegistrationPage()],
		})
			.then((res) => {
				if (res.status === 201 && res.data?._id) {
					alertSuccess({ customMessage: "Escape room creado." });
					history.push(`/escape-rooms/${res.data._id}`);
				}
			})
			.catch((err) => {
				alertError({ error: err, customMessage: "No se pudo crear el escape room." });
				setLoading(false);
			});
	};

	return (
		<Card>
			<CardHeader title="Añadir Escape Room" />
			<CardBody>
				<form onSubmit={handleSubmit}>
					<TextField
						autoFocus
						fullWidth
						label="Nombre"
						value={name}
						onChange={(e) => setName(e.target.value)}
						margin="normal"
						variant="outlined"
						disabled={loading}
					/>
					<div style={{ marginTop: 16 }}>
						<Button
							type="submit"
							variant="contained"
							color="primary"
							disabled={!name.trim() || loading}
						>
							{loading ? "Creando…" : "Crear"}
						</Button>
					</div>
				</form>
			</CardBody>
		</Card>
	);
}
